import { render, staticRenderFns } from "./SatisfactionSurveySettings.vue?vue&type=template&id=0b597135"
import script from "./SatisfactionSurveySettings.vue?vue&type=script&lang=js"
export * from "./SatisfactionSurveySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports